import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import FullWidthFeature from '~/components/blocks/acf/FullWidthFeature';

import { AcfLink } from '~/utilities/propTypes';

import fullWidth1 from '~/images/exampleBlocks/fullWidth1.png';
import fullWidth2 from '~/images/exampleBlocks/fullWidth2.png';

const FullWidthFeatureBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockFullWidthFeature
}) => (
    <FullWidthFeature
        {...{
            ...blockFullWidthFeature,
            globalBlockOptions,
            attributes
        }}
    />
);

FullWidthFeatureBlock.propTypes = {
    blockFullWidthFeature: PropTypes.shape({
        imageRight: PropTypes.bool,
        image: PropTypes.shape({}).isRequired,
        category: PropTypes.string,
        title: PropTypes.string,
        copy: PropTypes.string,
        features: PropTypes.arrayOf(
            PropTypes.shape({
                icon: PropTypes.string,
                feature: PropTypes.string.isRequired
            })
        ),
        ctas: PropTypes.arrayOf(
            PropTypes.shape({
                link: AcfLink
            })
        )
    }).isRequired
};

export default FullWidthFeatureBlock;

export const fragment = graphql`
    fragment FullWidthFeatureBlockFragment on WpAcfFullWidthFeatureBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockFullWidthFeature {
            imageRight
            image {
                altText
                sourceUrl
                localFile {
                    childImageSharp {
                        gatsbyImageData
                    }
                }
            }
            category
            title
            copy
            features {
                icon
                feature
            }
            ctas {
                link {
                    url
                    title
                }
                useComparisonTable
                comparisonTableProductCategory {
                    id
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Full Width Feature',
        description:
            'Image required: 1.34 Aspect Ratio, Minimum 990px x 740px. Intended to be a png.',
        props: {
            name: 'acf/full-width-feature',
            blockFullWidthFeature: {
                title: 'Full Width Feature Title',
                copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                category: 'Category',
                imageRight: false,
                image: {
                    sourceUrl: fullWidth1
                },
                features: [
                    {
                        icon: 'plus',
                        feature: 'Feature 1'
                    },
                    {
                        icon: 'coin',
                        feature: 'Feature 2'
                    },
                    {
                        icon: 'shopping-bag',
                        feature: 'Feature 3'
                    }
                ],
                ctas: [
                    {
                        link: {
                            title: 'Learn More',
                            url: '#'
                        }
                    }
                ]
            }
        }
    },
    {
        variant: 'Image Right Full Width Feature',
        props: {
            name: 'acf/full-width-feature',
            blockFullWidthFeature: {
                title: 'Full Width Feature Title',
                copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                imageRight: true,
                image: {
                    sourceUrl: fullWidth2
                }
            }
        }
    }
];
